"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _CarouselContext = require("./CarouselContext");
var _CarouselThumbnail = _interopRequireDefault(require("./CarouselThumbnail"));
var _StackView = require("../StackView");
var _ThemeProvider = require("../ThemeProvider");
var _ViewportProvider = require("../ViewportProvider");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CarouselThumbnailNavigation = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    thumbnails = []
  } = _ref;
  const viewport = (0, _ViewportProvider.useViewport)();
  const {
    alignItems
  } = (0, _ThemeProvider.useThemeTokens)('CarouselThumbnail', {}, {
    viewport
  });
  const {
    totalItems
  } = (0, _CarouselContext.useCarousel)();
  if (thumbnails.length !== totalItems) {
    throw new Error('Thumbnail set provided does not match the number of slides in the carousel');
  }
  const {
    containerPaddingTop: thumbnailContainerPaddingTop
  } = (0, _ThemeProvider.useThemeTokens)('CarouselThumbnail');
  const stackWrapTokens = {
    justifyContent: 'flex-start'
  };
  const containerStyles = {
    justifyContent: 'center',
    alignItems,
    paddingTop: thumbnailContainerPaddingTop
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
    style: containerStyles,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StackView.StackWrap, {
      direction: "row",
      tokens: stackWrapTokens,
      space: 2,
      ref: ref,
      children: thumbnails.map((_ref2, index) => {
        let {
          accessibilityLabel,
          alt,
          src
        } = _ref2;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CarouselThumbnail.default, {
          accessibilityLabel: accessibilityLabel,
          alt: alt,
          index: index,
          src: src
        }, src);
      })
    })
  });
});
CarouselThumbnailNavigation.displayName = 'CarouselThumbnailNavigation';
CarouselThumbnailNavigation.propTypes = {
  /**
   * An array of objects containing information on the thumbnail images.
   */
  thumbnails: _propTypes.default.arrayOf(_propTypes.default.shape({
    accessibilityLabel: _propTypes.default.string,
    alt: _propTypes.default.string,
    src: _propTypes.default.string
  })).isRequired
};
var _default = exports.default = CarouselThumbnailNavigation;